var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Row, Col } from "../index";
import { getCssVarValue } from "./Utils";
import { themeListener } from "../hooks/listeners";
function Widgets(props) {
    var components = props.components;
    themeListener(function () {
        try {
            var backing = document.getElementById("tol-app-background");
            backing.style.backgroundColor = getCssVarValue("--bs-body-darker");
        }
        catch (_a) {
            return;
        }
    });
    var getSm = function (type) {
        switch (type) {
            case 'sm':
                return 6;
            default:
                return 12;
        }
    };
    var getLg = function (type) {
        switch (type) {
            case 'sm':
                return 3;
            case 'md':
                return 6;
            default:
                return 12;
        }
    };
    var getHeight = function (type) {
        switch (type) {
            case 'sm':
                return 150;
            case 'md':
                return 450;
            case 'lg':
                return 450;
            case 'xl':
                return 600;
        }
    };
    var rowStyle = {
        marginLeft: 0,
        marginRight: 0,
        paddingLeft: 12,
        paddingRight: 12,
        marginBottom: -16
    };
    var colStyle = {
        paddingLeft: 0,
        paddingRight: 0
    };
    return (_jsx("div", { children: _jsx(Row, __assign({ style: rowStyle }, { children: components.map(function (item, index) {
                return (_jsx(Col, __assign({ sm: getSm(item.type), lg: getLg(item.type), style: colStyle }, { children: _jsx("div", __assign({ className: "tol-widget", style: { height: getHeight(item.type) } }, { children: item.component })) }), "tol-widget-".concat(index)));
            }) })) }));
}
export default Widgets;
